import { render, staticRenderFns } from "./QueueMenuV2026.vue?vue&type=template&id=c4e85306&scoped=true"
import script from "./QueueMenuV2026.vue?vue&type=script&lang=js"
export * from "./QueueMenuV2026.vue?vue&type=script&lang=js"
import style0 from "./QueueMenuV2026.vue?vue&type=style&index=0&id=c4e85306&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e85306",
  null
  
)

export default component.exports